import React, { useEffect, createContext } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
// import { MenuItem } from './interfaces/Menu.interfaces';
import { Landing } from './Pages/Landing/Landing';
import './App.scss';
import { PlateletRichPlasma } from './Pages/Services/PlateletRichPlasma/PlateletRichPlasma';
import { StemCells } from './Pages/Services/StemCells/StemCells';
import { HormoneReplacement } from './Pages/Services/HormoneReplacement/HormoneReplacement';
import { NeuralTherapy } from './Pages/Services/NeuralTherapy/NeuralTherapy';
import { ServicePage } from './Pages/Services/ServicePage/ServicePage';
import { FunctionalMedicine } from './Pages/Services/FunctionalMedicine/FunctionalMedicine';
import { VitaminInfusion } from './Pages/Services/VitaminInfusion/VitaminInfusion';
import { AppointmentRoot } from './Pages/AppointmentFlow/AppointmentRoot';

export interface ClientDataContextProps {
  clientWidth: number;
}

export const ClientDataContext = createContext<ClientDataContextProps>({
  clientWidth: document.getElementById('root').clientWidth,
});

const LegacyServicesRedirect = () => {
  const location = useLocation();
  return (
    <Navigate
      to={location.pathname.replace(/^\/services/, '/wellness-notes')}
      replace
    />
  );
};

export const App = () => {
  // const menuItems: MenuItem[] = [
  //   {
  //     endpoint: '/',
  //     icon: 'home',
  //     name: 'Inicio',
  //   },
  // ];

  useEffect(() => {}, []);

  const switchAuth = (): React.ReactElement => {
    return (
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/wellness-notes">
          <Route index element={<ServicePage />} />
          <Route path="platelet-rich-plasma" element={<PlateletRichPlasma />} />
          <Route path="stem-cells" element={<StemCells />} />
          <Route path="hormone-replacement" element={<HormoneReplacement />} />
          <Route path="pain-control-management" element={<NeuralTherapy />} />
          <Route path="functional-medicine" element={<FunctionalMedicine />} />
          <Route path="vitamin-infusion" element={<VitaminInfusion />} />
        </Route>
        <Route path="/services/*" element={<LegacyServicesRedirect />} />
        <Route path="/book-an-appointment" element={<AppointmentRoot />} />
      </Routes>
    );
  };

  return switchAuth();
};
